import * as PIXI from "pixi.js";
import ButtonLayer from "../../layers/ButtonLayer";
import TextureManager from "../../managers/TextureManager";
import SoundManager from "../../managers/SoundManager";
import { Sounds } from "../../types/Enum";
import { EventBus, EnumEventBus } from "../../managers/EventBus";

const BUTTON_PATH = "./images/buttons/"


export default class BaseButton extends PIXI.Sprite {
  private ButtonLayer: ButtonLayer;
  EventBus = EventBus;
  EnumEventBus = EnumEventBus
  name: string;
  regular: string;
  hover: string;
  pressed: string;
  soundType: Sounds;
  constructor(name: string, soundType: Sounds, addToCon = true) {
    super();
    this.name = name;
    this.soundType = soundType;
    this.ButtonLayer = ButtonLayer.getInstance();

    this.anchor.set(.5);

    this.generateButtonPaths();
    this.addInterActivity();
    this.addTexture();
    addToCon && this.addToContainer();
    this.handleEvents();

    this.EventBus.on(EnumEventBus.setAllButtonIntractvy, v => this.setInterActivity(Boolean(v)));
  }
  handlePress() { }
  generateButtonPaths() {
    this.regular = `${BUTTON_PATH}${this.name}.png`;
    this.hover = `${BUTTON_PATH}${this.name}_hover.png`;
    this.pressed = `${BUTTON_PATH}${this.name}_pressed.png`;
  }
  handleEvents() {
    this.on("mousedown", () => this._handlePress());
    this.on("mouseover", () => this.exchangeTexture(this.hover));
    this.on("mouseout", () => this.exchangeTexture(this.regular));
    this.on("mouseup", () => this.exchangeTexture(this.regular))
    this.on("touchstart", () => this._handlePress());
    this.on("touchend", () => this.exchangeTexture(this.regular))
  }
  _handlePress() {
    this.exchangeTexture(this.pressed);
    SoundManager.play(this.soundType);
    this.handlePress();
  }
  addTexture() {
    this.exchangeTexture(this.regular);
  }
  exchangeTexture(path: string) {
    const texture = TextureManager.getTexture(path);
    this.texture = texture;
  }
  addInterActivity() {
    this.interactive = true;
    this.cursor = "pointer";
  }
  setInterActivity(v: boolean) {
    this.interactive = v;
  }
  addToContainer() {
    this.ButtonLayer.addChild(this);
  }
}